"use client";

import React from "react";
import { ArrowRight, ShieldCheck, Stethoscope, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheClose() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const spineSurgeryProcedures = [{
    id: 1,
    name: "Surgeon & Surgical Team",
    cost: "€4,800",
    hse: "€4,800"
  }, {
    id: 2,
    name: "Hospital & Theatre Fees",
    cost: "€5,200",
    hse: "€5,200"
  }, {
    id: 3,
    name: "Anaesthesia Services",
    cost: "€1,200",
    hse: "€1,200"
  }, {
    id: 4,
    name: "Post-Op Recovery & Nursing",
    cost: "€2,700",
    hse: "€2,700"
  }];
  const painManagementProcedures = [{
    id: 1,
    name: "Specialist Consultation",
    cost: "€250",
    hse: "€0"
  }, {
    id: 2,
    name: "MRI & Diagnostic Scans",
    cost: "€450",
    hse: "€0"
  }, {
    id: 3,
    name: "Epidural/Facet Injections",
    cost: "€1,200",
    hse: "€1,200"
  }, {
    id: 4,
    name: "CBD Admin Support",
    cost: "€500",
    hse: "€0"
  }];
  return;
}